module.exports = __webpack_public_path__ + "static/media/battery_full.b26cc9b9.svg";